import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/_helpers/token-storage.service';
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {
  public projectObj:any;
  public projName:any;
  public projectId:any;
  public appId:any;
  public appName:any;
  public projectSelectRef: any;
  public displayFlag:any;
  public skriptmateUrl: any;
  public platform:any='';
  public userType: any = null;
  public res: any;
  public userObj: any;
  public licenseExpired: boolean = false;
  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService
     ) { 
    this.displayFlag = false;
    this.skriptmateUrl = environment.skriptmateUrl;
  }

  ngOnInit(): void {
    this.initialize();
    
  }
  
  

  initialize(){
    if(this.tokenStorage.getToken()) {
      this.displayFlag=true;
    }
  }



}
